import React from "react";

function Footer() {
    return (
        <div className="container">
            <footer className="py-3 my-4 text-center">
                <ul className="nav justify-content-center border-bottom pb-3 mb-3">
                    <li className="nav-item"><a href="/" className="nav-link px-2">Home</a></li>
                    <li className="nav-item"><a href="/About" className="nav-link px-2">About</a></li>
                    <li className="nav-item"><a href="/Projects" className="nav-link px-2">Projects</a></li>
                    <li className="nav-item"><a href="/Contact" className="nav-link px-2">Contact</a></li> 
                </ul>
                    <p className="text-center">© 2025 monsieurjaws.ca</p>
                    <a href="https://linkedin.com/in/jason-williams-9818a3294"><i className="bi bi-linkedin"></i></a>
                    <a href="https://github.com/MonsieurJAWs"><i className="bi bi-github"></i></a>
            </footer>
        </div>
    );
};
export default Footer;